export function isStaticNavigation() {
  return process.env.GATSBY_STATIC_NAVIGATION === 'true' || process.env.GATSBY_STATIC_NAVIGATION === '1';
}

